import { UseLazyQuery } from "@reduxjs/toolkit/dist/query/react/buildHooks"
import { useEffect } from "react"

const FetchingItems = <T,>({ useLazyQuery, parameters, render }
    :
    {
        useLazyQuery: UseLazyQuery<any>
        parameters?: any
        render: (x: T | undefined, isLoading: boolean) => JSX.Element
    }
) => {

    const [query, status] = useLazyQuery()
    useEffect(() => {
        query(parameters)
    }, [useLazyQuery, parameters])

    return render(status.data as T | undefined, status.isLoading)
}

export default FetchingItems